import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import Button from "../../../generic/Button";
import { types } from "../../../../utils";


const MobileAuthButtons: FunctionComponent = () => (
  <div className="w-full pb-4 flex justify-around md:hidden">
    <LoginButton />
  </div>
);


const LoginButton: FunctionComponent = () => (
  <Link to='/auth/login'>
    <Button 
      text='LOGIN' 
      theme={types.buttonTypes.BUTTON_THEME_TYPES.PRIMARY} 
      styles='rounded-none w-[300px]'
    />
  </Link>
);


export default MobileAuthButtons;


